module.exports = __webpack_public_path__ + "images/empty-state-4841d667d1ea2016b1ecd1c98384be33.svg";